// Number formatting for budgets, kept out of the component files so those only
// export components and stay eligible for fast refresh.
import { currentLocale } from '../../i18n'

/** CLP has no minor unit, so pesos never show decimals. */
export function formatCLP(value, { compact = false } = {}) {
  if (value == null) return '—'
  return new Intl.NumberFormat(currentLocale(), {
    style: 'currency', currency: 'CLP', maximumFractionDigits: 0,
    ...(compact ? { notation: 'compact', maximumFractionDigits: 1 } : {}),
  }).format(value)
}

/** For a client rate quoted in dollars, never converted in place of showing it. */
export function formatUSD(value, { compact = false } = {}) {
  if (value == null) return '—'
  return new Intl.NumberFormat(currentLocale(), {
    style: 'currency', currency: 'USD',
    minimumFractionDigits: compact ? 0 : 2, maximumFractionDigits: compact ? 1 : 2,
    ...(compact ? { notation: 'compact' } : {}),
  }).format(value)
}

export function formatHours(value, { compact = false } = {}) {
  if (value == null) return '—'
  return new Intl.NumberFormat(currentLocale(), {
    maximumFractionDigits: compact ? 0 : 1,
    ...(compact ? { notation: 'compact' } : {}),
  }).format(value)
}

export function formatAmount(value, kind, opts) {
  return kind === 'money' ? formatCLP(value, opts) : formatHours(value, opts)
}

export function formatNumber(value, digits = 2) {
  if (value == null) return '—'
  return new Intl.NumberFormat(currentLocale(), { maximumFractionDigits: digits })
    .format(value)
}
